// =============================================================================
// MeuDriver — Admin Dashboard / Monthly Trend Chart (6m)
// =============================================================================

import { BarChart2 } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { formatCurrency } from '@/lib/utils'

export interface MonthTrend {
  month: string
  bookings: number
  revenue: number
}

interface Props {
  data: MonthTrend[]
  loading: boolean
}

export function AdminMonthlyChart({ data, loading }: Props) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-sm font-medium text-muted-foreground">
          <BarChart2 className="h-4 w-4" />
          Aulas concluídas — últimos 6 meses
        </CardTitle>
      </CardHeader>
      <CardContent>
        {loading ? (
          <Skeleton className="h-40 w-full" />
        ) : (
          <div className="space-y-3">
            <div className="flex items-end gap-3 h-36">
              {data.map((m) => {
                const max = Math.max(...data.map((d) => d.bookings), 1)
                const pct = Math.round((m.bookings / max) * 100)
                return (
                  <div key={m.month} className="flex-1 flex flex-col items-center gap-1 group">
                    <span className="text-[11px] font-medium text-muted-foreground opacity-0 group-hover:opacity-100 transition-opacity">
                      {m.bookings}
                    </span>
                    <div
                      className="w-full rounded-t-md bg-brand-500 hover:bg-brand-600 transition-colors"
                      style={{ height: `${Math.max(pct, m.bookings > 0 ? 6 : 1)}%` }}
                      title={`${m.bookings} aulas · ${formatCurrency(m.revenue)}`}
                    />
                  </div>
                )
              })}
            </div>
            <div className="flex gap-3">
              {data.map((m) => (
                <div key={m.month} className="flex-1 text-center">
                  <p className="text-[11px] text-muted-foreground capitalize">{m.month}</p>
                  <p className="text-[10px] text-muted-foreground/70">{formatCurrency(m.revenue)}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
